import { ConstractStudentDetails, ServiceConcept } from "../../service-concept/interfaces/serviceConcept";
import { ContractData, ContractDataRequest, GroupedConcept } from "./contractData";

export class Contract {
  contractData: ContractData;
  conceptService: ServiceConcept[];
  details: ConstractStudentDetails[];
}

export class ContractResponse {
  contractData: ContractDataRequest;
  conceptService: ServiceConcept[];
  details: ConstractStudentDetails[];
}
